import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { QUERY_KEYS } from '@/utils/query-keys';
import { BeraV2Service } from '@/infra/services/bera-v2';
import type { BeraSummaryFinishV2 } from '@/types/Bera';

export interface FinishBeraJobSummaryV2Params {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = BeraV2Service.getInstance();

export function useFinishBeraJobSummaryV2() {
	const queryClient = useQueryClient();

	return useMutation<BeraSummaryFinishV2, AxiosError<{ message?: string }>, FinishBeraJobSummaryV2Params>(
		(params: FinishBeraJobSummaryV2Params) => Service.finishJobSummary(params),
		{
			onSuccess: () => {
				queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_SUMMARY_RESULT_V2]);
			},
			onError: (error) => {
				const description = error.response?.data?.message ?? error.message;

				notification.error({
					message: I18n.get('Ops... something happened!'),
					description: I18n.get(description)
				});
			}
		}
	);
}
